import React from 'react';
import { Routes, Route } from 'react-router-dom'
import ListPublicaciones from './Components/ListPublicaciones';
import PublicacionNew from './Components/ABM/PublicacionNew'; 
import PublicacionEdit from './Components/ABM/PublicacionEdit'
import CreacionMasivaPublicaciones from './Components/Excel/CreacionMasivaPublicaciones';
import ActualizacionMasivaPublicaciones from './Components/Excel/ActualizacionMasivaPublicaciones';

export default class AdmPublicaciones extends React.Component {
    render () {
        return (
            <div>
                <Routes>
                    <Route path="" element={<ListPublicaciones/>}/>
                    <Route path="Nueva/:idSeller" element={<PublicacionNew/>}/>
                    <Route path="Editar/:idSeller/:id" element={<PublicacionEdit/>}/>
                    <Route path="CreacionMasiva" element={<CreacionMasivaPublicaciones/>}/>
                    <Route path="ActualizacionMasiva" element={<ActualizacionMasivaPublicaciones/>} />
                </Routes>
            </div>
        ); 
    }
}